module.exports = __webpack_public_path__ + "9674833fbf0c302db119a7e9c3891a2e.jpg";